import ProgressTestCourseView from './component';
import _routes from './routes';

export const routes = _routes;

export default ProgressTestCourseView;



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/ProgressTestCourseView/index.js